module.exports = __webpack_public_path__ + "static/media/io.2d90626c.svg";